<ng-container *ngIf="showData">
  <ng-container *ngIf="!error; else errorTemplate">
    <div
      *ngIf="!specialMessage; else specialMessageTemplate"
      [ngClass]="isVertical ? 'vertical' : 'horizontal'"
      class="tracking-container flex flex-col"
    >
      <div class="text-info-wrapper">
        <span class="bold-text">Seguimiento de mi pedido:</span>
        <span class="bold-text green">{{ statusAnnotation }}</span>
      </div>
      <div class="progress-wrapper">
        <div class="progressBar-wrapper">
          <div class="progressBar barBackground">
            <div
              *ngFor="let marker of getMarkersArray()"
              class="marker absolute"
              [ngClass]="marker.class"
              [ngStyle]="isVertical ? { top: marker.position + '%' } : { left: marker.position + '%' }"
            >
              <div class="marker-text-wrapper">
                <span class="marker-text">{{ marker.text }}</span>
                <span class="marker-text text2">{{ marker.text2 }}</span>
              </div>
              <div class="icon-container" [class.completed]="marker.position < fillPercentage">
                <ion-icon [icon]="marker.image"></ion-icon>
              </div>
            </div>
          </div>
          <div
            class="progressBar barFill"
            [ngStyle]="isVertical ? { height: fillPercentage + '%' } : { width: fillPercentage + '%' }"
          ></div>
        </div>
      </div>

      <div class="w-100 flex flex-row justify-between">
        <div class="w-1/3"></div>
        <div *ngIf="trackingData.url && showTrackingLink" class="flex w-1/3 flex-row items-center justify-center">
          <a [href]="trackingData.url" target="_blank" class="trackingLink"
            >Ver más sobre el seguimiento de mi pedido</a
          >
        </div>
        <div class="flex w-1/3 flex-row justify-end">
          <ion-button
            *ngIf="isDelayed"
            [disabled]="order.shippingDelayReported"
            color="danger"
            (click)="reportDelayConfirmation(order)"
          >
            {{
              !order.shippingDelayReported ? 'Informar de retraso de mi pedido' : 'Hemos recibido tu aviso de retraso'
            }}
          </ion-button>
        </div>
      </div>
    </div>
    <ng-template #specialMessageTemplate>
      <div class="flex w-full flex-row justify-between">
        <p class="text-xl">{{ specialMessage }}</p>
        <div class="flex w-1/3 flex-row justify-end">
          <ion-button
            *ngIf="isDelayed"
            [disabled]="order.shippingDelayReported"
            color="danger"
            (click)="reportDelayConfirmation(order)"
          >
            {{
              !order.shippingDelayReported ? 'Informar de retraso de mi pedido' : 'Hemos recibido tu aviso de retraso'
            }}
          </ion-button>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-template #errorTemplate> Ha ocurrido un error al cargar los datos de seguimiento </ng-template>
</ng-container>
